<template>
  <div class="login">
    <form
      action="/login"
      method="post"
      class="login__form form login-form"
      @submit.prevent="onSubmit"
    >
      <h1>Вход в NormaCS 4.x</h1>
      <div v-if="error" class="form__errors">{{ error }}</div>
      <div class="form__field">
        <label class="form__label">
          <div>Логин</div>
          <input
            v-model="login"
            name="login"
            type="text"
            required
            autofocus
            class="form__input"
            @keydown.enter.exact.prevent
            @keyup.enter.exact="onSubmit"
            @keydown.enter.shift.exact="onSubmit"
          />
          <span v-if="appInfo.loginmode.includes('domain')" class="form__prompt"
            >(доступен вход через доменный логин)</span
          >
        </label>
      </div>
      <div class="form__field">
        <label class="form__label">
          <div>Пароль</div>
          <input
            v-model="password"
            name="password"
            type="password"
            class="form__input"
            required
          />
        </label>
      </div>
      <div class="form__checkbox checkbox">
        <label class="checkbox__label">
          <input
            v-model="remember"
            class="checkbox__input"
            name="remember"
            type="checkbox"
          />
          <span class="checkbox__icon">
            <svg class="icon-checkbox" width="16" height="16">
              <use xlink:href="#checkbox" />
            </svg>
            <svg class="icon-checkbox_checked" width="16" height="16">
              <use xlink:href="#checkbox-checked" />
            </svg>
          </span>
          <span class="checkbox__text">Запомнить меня</span>
        </label>
      </div>
      <button class="button form__submit" @click.prevent="onSubmit">
        Войти
      </button>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      login: '',
      password: '',
      remember: false,
      error: ''
    };
  },

  computed: {
    ...mapState(['appInfo'])
  },

  methods: {
    onSubmit() {
      this.error = '';

      this.$store
        .dispatch('userLogin', {
          login: this.login,
          password: this.password,
          remember: this.remember
        })
        .catch(error => {
          let errorMessage = 'Неверный логин или пароль. Попробуйте еще раз.';

          if (
            error.response &&
            error.response.status === 401 &&
            error.response.data.errorMessage
          ) {
            errorMessage = error.response.data.errorMessage;
          }
          this.error =
            error.response && error.response.status === 401
              ? errorMessage
              : error.message;
        });
    }
  }
};
</script>

<style src="./login.css" />
